var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEclipPackageCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2858 18.5719V9.42902C24.2854 9.02819 24.1796 8.63451 23.979 8.28749C23.7784 7.94046 23.4901 7.65229 23.1429 7.45187L15.1429 2.88045C14.7955 2.67983 14.4013 2.57422 14.0001 2.57422C13.5988 2.57422 13.2047 2.67983 12.8572 2.88045L4.85721 7.45187C4.51008 7.65229 4.22176 7.94046 4.02117 8.28749C3.82058 8.63451 3.71477 9.02819 3.71436 9.42902V18.5719C3.71477 18.9727 3.82058 19.3664 4.02117 19.7134C4.22176 20.0604 4.51008 20.3486 4.85721 20.549L12.8572 25.1204C13.2047 25.3211 13.5988 25.4267 14.0001 25.4267C14.4013 25.4267 14.7955 25.3211 15.1429 25.1204L23.1429 20.549C23.4901 20.3486 23.7784 20.0604 23.979 19.7134C24.1796 19.3664 24.2854 18.9727 24.2858 18.5719Z",
    stroke: "#A614B9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25.52V14",
    stroke: "#A614B9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5713 16.2861L13.9999 11.7147L9.42843 16.2861",
    stroke: "#A614B9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEclipPackageCard);
export default __webpack_public_path__ + "static/media/icon-eclip-package-card.3dd836bab18999b1c4701d3f88994951.svg";
export { ForwardRef as ReactComponent };